<div class="portal-list-page">
  <div class="page-header">
    <h2 class="page-title">Makine Modelleri</h2>
    <lib-button variant="primary" (buttonClick)="openAdd()">
      <span class="btn-content">
        <svg lucidePlus [size]="16" [strokeWidth]="2.25" aria-hidden="true"></svg>
        Ekle
      </span>
    </lib-button>
  </div>

  <div class="search-bar search-bar-wide">
    <input
      class="search-input"
      type="text"
      placeholder="Ada göre ara..."
      [(ngModel)]="searchName"
      (keyup.enter)="onSearch()"
    />
    <input
      class="search-input"
      type="text"
      placeholder="Makine türü..."
      [(ngModel)]="searchMachineType"
      (keyup.enter)="onSearch()"
    />
    <input
      class="search-input"
      type="text"
      placeholder="Marka..."
      [(ngModel)]="searchBrand"
      (keyup.enter)="onSearch()"
    />
    <lib-button variant="outline" size="sm" (buttonClick)="onSearch()">
      <span class="btn-content">
        <svg lucideSearch [size]="15" [strokeWidth]="2" aria-hidden="true"></svg>
        Ara
      </span>
    </lib-button>
    @if (searchName || searchBrand || searchMachineType) {
      <lib-button variant="text" size="sm" (buttonClick)="clearSearch()">Temizle</lib-button>
    }
  </div>

  @if (loading()) {
    <div class="loading-overlay">
      <div class="spinner"></div>
      <p>Yükleniyor...</p>
    </div>
  } @else {
    <div class="table-wrapper">
      <table class="data-table">
        <thead>
          <tr>
            <th class="action-col">
              <div class="row-actions">
                <lib-button variant="text" size="sm" class="portal-icon-btn" (buttonClick)="load()" title="Yenile">
                  <svg lucideRefreshCw [size]="16" [strokeWidth]="2" aria-hidden="true"></svg>
                </lib-button>
              </div>
            </th>
            <th>Ad</th>
            <th>Makine Türü</th>
            <th>Marka</th>
            <th>Görsel</th>
            <th>Aktif</th>
          </tr>
        </thead>
        <tbody>
          @if (items().length === 0) {
            <tr><td colspan="6" class="empty-row">Kayıt bulunamadı</td></tr>
          }
          @for (item of items(); track item.id) {
            <tr>
              <td class="action-col">
                <div class="row-actions">
                  <lib-button variant="text" size="sm" class="portal-icon-btn" (buttonClick)="openEdit(item)" title="Düzenle">
                    <svg lucidePencil [size]="16" [strokeWidth]="2" aria-hidden="true"></svg>
                  </lib-button>
                  <lib-button
                    variant="text"
                    size="sm"
                    class="portal-icon-btn portal-icon-btn--danger"
                    (buttonClick)="delete(item)"
                    title="Sil"
                  >
                    <svg lucideTrash2 [size]="16" [strokeWidth]="2" aria-hidden="true"></svg>
                  </lib-button>
                </div>
              </td>
              <td>{{ item.name }}</td>
              <td>{{ item.machineType || '-' }}</td>
              <td>{{ item.brand || '-' }}</td>
              <td>
                <button
                  type="button"
                  class="image-btn"
                  (click)="openImageDialog(item)"
                  [title]="item.fileUrl ? 'Görseli görüntüle' : 'Görsel ekle'"
                >
                  @if (item.fileUrl) {
                    <svg lucideImage [size]="16" [strokeWidth]="2" aria-hidden="true"></svg>
                  } @else {
                    <svg lucidePlus [size]="16" [strokeWidth]="2" aria-hidden="true"></svg>
                  }
                </button>
              </td>
              <td>
                <span class="badge" [class.badge-yes]="item.isActive" [class.badge-no]="!item.isActive">
                  {{ item.isActive ? 'Aktif' : 'Pasif' }}
                </span>
              </td>
            </tr>
          }
        </tbody>
      </table>
    </div>

    <div class="pagination">
      <lib-button variant="text" size="sm" class="portal-icon-btn" [disabled]="page() === 0" (buttonClick)="prevPage()" title="Önceki">
        <svg lucideChevronLeft [size]="16" [strokeWidth]="2" aria-hidden="true"></svg>
      </lib-button>
      <span class="page-info">Sayfa {{ page() + 1 }} / {{ totalPages() || 1 }}</span>
      <lib-button variant="text" size="sm" class="portal-icon-btn" [disabled]="page() >= totalPages() - 1" (buttonClick)="nextPage()" title="Sonraki">
        <svg lucideChevronRight [size]="16" [strokeWidth]="2" aria-hidden="true"></svg>
      </lib-button>
    </div>
  }
</div>

@if (showFormDialog()) {
  <div class="dialog-backdrop" (click)="closeFormDialog()"></div>
  <div class="dialog">
    <div class="dialog-header">
      <h3>{{ isEdit() ? 'Makine Modelini Düzenle' : 'Yeni Makine Modeli' }}</h3>
      <button type="button" class="dialog-close" (click)="closeFormDialog()" aria-label="Kapat">
        <svg lucideX [size]="16" [strokeWidth]="2" aria-hidden="true"></svg>
      </button>
    </div>
    <div class="dialog-body">
      <div class="form-field">
        <label class="field-label">Ad *</label>
        <input
          class="form-input"
          type="text"
          [ngModel]="formModel().name"
          (ngModelChange)="updateField('name', $event)"
          placeholder="Model adı"
        />
      </div>
      <div class="form-field">
        <label class="field-label">Makine Türü *</label>
        <select
          class="form-select"
          [ngModel]="formModel().machineTypeId"
          (ngModelChange)="updateField('machineTypeId', $event)"
          [disabled]="optionsLoading()"
        >
          <option value="">-- Seçiniz --</option>
          @for (type of machineTypeOptions(); track type.id) {
            <option [value]="type.id">{{ type.name }}</option>
          }
        </select>
      </div>
      <div class="form-field">
        <label class="field-label">Marka *</label>
        <select
          class="form-select"
          [ngModel]="formModel().brandId"
          (ngModelChange)="updateField('brandId', $event)"
          [disabled]="optionsLoading()"
        >
          <option value="">-- Seçiniz --</option>
          @for (brand of brandOptions(); track brand.id) {
            <option [value]="brand.id">{{ brand.name }}</option>
          }
        </select>
      </div>
      <div class="form-field checkbox-field">
        <input
          type="checkbox"
          id="machineModelIsActive"
          [ngModel]="formModel().isActive"
          (ngModelChange)="updateField('isActive', $event)"
        />
        <label for="machineModelIsActive">Aktif</label>
      </div>
    </div>
    <div class="dialog-footer">
      <lib-button variant="outline" (buttonClick)="closeFormDialog()">İptal</lib-button>
      <lib-button variant="primary" [disabled]="formSaving()" (buttonClick)="save()">
        {{ formSaving() ? 'Kaydediliyor...' : 'Kaydet' }}
      </lib-button>
    </div>
  </div>
}

@if (showImageDialog()) {
  <div class="dialog-backdrop" (click)="closeImageDialog()"></div>
  <div class="dialog">
    <div class="dialog-header">
      <h3>Model Görseli</h3>
      <button type="button" class="dialog-close" (click)="closeImageDialog()" aria-label="Kapat">
        <svg lucideX [size]="16" [strokeWidth]="2" aria-hidden="true"></svg>
      </button>
    </div>
    <div class="dialog-body">
      @if (imageSaving()) {
        <p>Görsel işleniyor...</p>
      } @else if (selectedModel()?.fileUrl) {
        <img class="preview-image" [src]="selectedModel()!.fileUrl!" alt="Model görseli" />
      } @else {
        <div class="form-field">
          <label class="field-label">Görsel seçin</label>
          <input class="form-input" type="file" accept="image/*" (change)="onImageSelected($event)" />
        </div>
      }
    </div>
    <div class="dialog-footer">
      <lib-button variant="outline" (buttonClick)="closeImageDialog()">Kapat</lib-button>
      @if (selectedModel()?.fileUrl) {
        <lib-button variant="danger" [disabled]="imageSaving()" (buttonClick)="deleteImage()">Görseli Sil</lib-button>
      } @else {
        <lib-button variant="primary" [disabled]="imageSaving() || !selectedImageFile" (buttonClick)="saveImage()">
          Yükle
        </lib-button>
      }
    </div>
  </div>
}
